import React from 'react';

import { Modal, message } from 'antd';

import fetch from '../../../fetch';

import reqwest from 'reqwest';


/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insertBasicData = (data) => {
	return fetch.post('ky/project/school/insertBasicData', data)
		.then(response => {
		});
}

const insertMemberData = (data) => {
	return fetch.post('ky/project/school/insertMemberData', data)
		.then(response => {
		});
}

const insertBudgetData = (data) => {
	return fetch.post('ky/project/school/insertBudgetData', data)
		.then(response => {

		});
}

const insertFileData = (data, projectId) => {

	const formData = new FormData();

	data.forEach(file => {
		formData.append('files', file[0]);
	});

	reqwest({
		url: fetch.base + 'ky/project/school/insertFileData/' + projectId,
		method: 'post',
		processData: false,
		data: formData,
		crossOrigin: true, 
		withCredentials: true,
		success: (response) => {

			var data = JSON.parse(response);

			if(data.code === 200) {
				Modal.success({
					title: '文件上传',
					content: '文件上传成功！',
					onOk:() => {
					}
				});
			} else {
				Modal.error({
					title: '文件上传',
					content: data.message,
					onOk:() => {
					}
				});
			}


		},
	});
}


const declareProject = (data) => {

	const formData = new FormData();

	formData.append('projectBase', JSON.stringify(data.baseData))
	formData.append('projectMember', JSON.stringify(data.memberData))
	formData.append('projectBudgetFee', JSON.stringify(data.budgetData))
	formData.append('type', data.type)

	data.filesData.forEach(file => {
		file[0] ? formData.append('projectFiles', file[0]) : '';
	});

	return reqwest({
		url: fetch.base + 'ky/project/school/declareProject',
		method: 'post',
		processData: false,
		data: formData,
		crossOrigin: true, 
		withCredentials: true,
		success: (response) => {

			var data = JSON.parse(response);

			if(data.code === 200) {
				Modal.success({
					title: '项目新增成功',
					content: data.message,
					onOk:() => {
					}
				});
			} else if (data.code === 201) {
				return response
			}
			else {
				Modal.error({
					title: '项目申报失败',
					content: data.message,
					onOk:() => {
					}
				});
			}


		},
	});
}


const editProject = (data) => {

	const formData = new FormData();

	formData.append('projectBase', JSON.stringify(data.baseData))
	formData.append('projectMember', JSON.stringify(data.memberData))
	formData.append('projectBudgetFee', JSON.stringify(data.budgetData))
	if (data.hasFilesData) {
		formData.append('projectHasFiles', JSON.stringify(data.hasFilesData))
	}
	formData.append('type', data.type)

	data.filesData.forEach(file => {
		file[0] ? formData.append('projectFiles', file[0]) : '';
	});

	return reqwest({
		url: fetch.base + 'ky/project/school/editProject',
		method: 'post',
		processData: false,
		data: formData,
		crossOrigin: true, 
		withCredentials: true,
		success: (response) => {
			
			var data = JSON.parse(response);

			if(data.code === 200) {
				Modal.success({
					title: '项目申报成功',
					content: data.message,
					onOk:() => {
					}
				});
			} else if (data.code === 201) {
				Modal.success({
					title: '项目编辑成功',
					content: data.message,
					onOk:() => {
					}
				});
			}
			else {
				Modal.error({
					title: '项目编辑失败',
					content: data.message,
					onOk:() => {
					}
				});
			}
		},
	});
}

export default {
	insertBasicData,
	insertMemberData,
	insertBudgetData,
	insertFileData,
	declareProject,
	editProject
}